<script>
	/**
	 * Yes! This code is dirty and disgusting
	 * but it's working, okay?! :-)
	 */
	export default {
		mounted() {
			const el = this.$el;
			const currents = el.querySelectorAll('a.current');
			for (let i = 0; i < currents.length; i++) {
				const parentUl = currents[i].parentElement.parentElement;

				// add active class to parent UL
				parentUl
					.classList
					.add('active');

				// add active class to wrapper
				if (parentUl.previousElementSibling) {
					parentUl
						.previousElementSibling
						.classList
						.add('active');

					if (parentUl.previousElementSibling.firstElementChild) {
						// add active class to trigger
						parentUl
							.previousElementSibling
							.firstElementChild
							.classList
							.add('active');
					}
				}
			}
		},
	};
</script>

<template src="./ge-menu.html"></template>
<style src="./ge-menu.scss"></style>



// WEBPACK FOOTER //
// ge-menu.vue?f56a62a8